<template>
    <div class="h-40px">
        <img v-if="user && user.photo_url"
             :src="user.photo_url"
             :alt="''"
             class="rounded overflow-hidden w-40px h-40px bg-light-primary"/>
        <UserInitials v-else :name="user ? user.name : '?'"/>
    </div>
</template>

<script>
import UserInitials from "./UserInitials.vue";

export default {
    components: {UserInitials},

    props: {
        user: {
            type: Object,
            default: null
        }
    }
}
</script>
